import React from 'react';

import { Box, HStack, Stack, UseDisclosureProps } from '@chakra-ui/react';
import { toArray } from 'lodash';
import map from 'lodash/map';
import { useSelector } from 'react-redux';
import { customTheme } from 'theme';

import { PrimaryButton, Select } from 'components/DataEntry';
import { OktaIdentitiesUsingRole } from 'containers/Jit/MaskingPolicies/Components/DataPolicyWizard/Components/Criteria/Conditions/OktaIdentitiesUsingRole';
import { addConditionButtonStyles } from 'containers/Jit/MaskingPolicies/Components/DataPolicyWizard/styles';
import {
  renderDataPolicyConditionLabel,
  renderDisplayNameBox,
} from 'containers/Jit/MaskingPolicies/Components/DataPolicyWizard/utils';
import { seletMaskingPolicies } from 'containers/Jit/MaskingPolicies/selectors';

interface Props {
  state: Record<string, any>;
  onClickAddCondition: (principalType: Record<string, any>) => void;
  updateState: (state: any) => void;
  identitiesUsingRoleDisclosure: UseDisclosureProps;
}

export const DataPolicyResourceConditions = (props: Props) => {
  const {
    state,
    onClickAddCondition,
    updateState,
    identitiesUsingRoleDisclosure,
  } = props;
  const { resources } = useSelector(seletMaskingPolicies);

  //render attributes like user names, role names, tag key pairs
  const renderAttributes = (item, field) => {
    return (
      <Box>
        <HStack>
          {renderDisplayNameBox(item?.display_name, '28%')}
          {renderDisplayNameBox('is', '10%', customTheme.colors.gray['250'])}
          <Box borderRadius={6} bg="white" flex={1} w="full">
            <Select
              options={state?.resourceOptions?.[item?.resource_type]}
              value={state?.[field]?.[item?.id]?.value}
              showClearIndicator={false}
              onChange={val =>
                updateState(prev => ({
                  ...prev,
                  [field]: {
                    ...prev?.[field],
                    [item.id]: { ...item, value: val },
                  },
                  isInvalid: false,
                }))
              }
              isLoading={resources?.[item?.resource_type]?.isLoading}
            />
          </Box>
          <OktaIdentitiesUsingRole
            account={state?.account}
            role={item.value?.data}
            disclosure={identitiesUsingRoleDisclosure}
            onClick={() => updateState({ currentRole: item.value?.data })}
          />
        </HStack>
      </Box>
    );
  };

  return (
    <Stack spacing={3}>
      <HStack justify="space-between">
        {renderDataPolicyConditionLabel(
          'IF',
          'the following condition is true',
          true,
        )}
        <Box>
          <PrimaryButton
            {...addConditionButtonStyles}
            onClick={() => onClickAddCondition(state?.principalType)}
          >
            + ADD
          </PrimaryButton>
        </Box>
      </HStack>

      <Stack spacing={5}>
        {!!state?.conditions &&
          map(toArray(state?.conditions), (o, index) => (
            <Stack
              py={6}
              px={6}
              spacing={6}
              bg={customTheme.colors.gray['50']}
              borderRadius={6}
            >
              {renderAttributes(o, 'conditions')}
            </Stack>
          ))}
      </Stack>
    </Stack>
  );
};
